export const BUSINESS = {
    name: "Masons Automotive",
    phoneDisplay: "+61 407 663 571",
    phoneTel: "tel:+61407663571",
    whatsappUrl:
        "https://wa.me/61407663571?text=" +
        encodeURIComponent("Hi Masons Automotive, I need a mobile mechanic."),
    email: "masonsautotech@gmail.com",
    location: "Gympie QLD 4570, Australia",
    hours: "Mon–Fri 10:00 AM – 4:00 PM · Sat–Sun 10:00 AM – 12:00 PM",
    hoursShort: "Mon–Fri 10–4 · Sat–Sun 10–12",
    pricingNote: "All prices are labour only — parts quoted upfront before any work begins.",
    googleReviewUrl: "https://www.google.com/search?q=Masons+Automotive+Gympie+QLD+reviews",
};
